var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-light text-center mb-0"},[_c('fa',{staticClass:"fa-spin fa-2x text-primary",attrs:{"icon":"circle-notch"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }